import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { customLocalStorage } from '@crehana/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var UIThemeContext = /*#__PURE__*/createContext(undefined);
export var UIThemeProvider = function UIThemeProvider(_ref) {
  var children = _ref.children;
  var initialTheme = customLocalStorage.getItem('crehana-dark-mode') ? 'dark' : 'light';
  var _useState = useState({
      theme: initialTheme,
      isDark: initialTheme === 'dark'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    theme = _useState2$.theme,
    isDark = _useState2$.isDark,
    setTheme = _useState2[1];
  var setOrRemoveThemeOfLocalStorage = function setOrRemoveThemeOfLocalStorage(isDarkMode) {
    var addAndRemoveClassTheme = function addAndRemoveClassTheme(_ref2) {
      var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4, _document$querySelect5, _document$querySelect6;
      var add = _ref2.add,
        remove = _ref2.remove;
      (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.classList) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.add) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.call(_document$querySelect2, add);
      (_document$querySelect4 = document.querySelector('html')) === null || _document$querySelect4 === void 0 ? void 0 : (_document$querySelect5 = _document$querySelect4.classList) === null || _document$querySelect5 === void 0 ? void 0 : (_document$querySelect6 = _document$querySelect5.remove) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.call(_document$querySelect5, remove);
    };
    if (isDarkMode) {
      customLocalStorage.setItem('crehana-dark-mode', 'true');
      addAndRemoveClassTheme({
        add: 'tw-dark',
        remove: 'tw-light'
      });
    } else {
      customLocalStorage.removeItem('crehana-dark-mode');
      addAndRemoveClassTheme({
        add: 'tw-light',
        remove: 'tw-dark'
      });
    }
  };
  useEffect(function () {
    setOrRemoveThemeOfLocalStorage(isDark);
  }, []);
  var toggleTheme = function toggleTheme() {
    var newTheme = theme === 'light' ? 'dark' : 'light';
    var darkMode = newTheme === 'dark';
    setOrRemoveThemeOfLocalStorage(darkMode);
    setTheme({
      theme: newTheme,
      isDark: darkMode
    });
  };
  var fullTheme = useMemo(function () {
    return {
      theme: theme,
      isDark: isDark,
      toggleTheme: toggleTheme
    };
  }, [isDark, theme]);
  return /*#__PURE__*/_jsx(UIThemeContext.Provider, {
    value: fullTheme,
    children: children
  });
};
export var useUITheme = function useUITheme() {
  var context = useContext(UIThemeContext);
  if (context === undefined) {
    throw new Error('useUITheme must be used within a UITheme provider.');
  }
  return context;
};
export default UIThemeProvider;